const ITEM_HEIGHT = 70;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + 8,
      //width: 250,
    },
  },
};
